const installmentTypes = Object.freeze({
    directFromPartner: 1
});
export const installmentTypesFullNamesMap = Object.freeze({
    [installmentTypes.directFromPartner]: 'Direct From Partner'
});
export default installmentTypes;
